import React, { JSX } from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import { LzTThemeColor } from '@lz/app/Theming/types';
import { Link } from 'react-router-dom';
import { LzTFunctionSimple, LzTOpenObject } from '@lz/typings';
import { lzFSortArrayOfObjectsByPosition } from '@lz/services/Utils';

import './Toolbar.scss';

export type LzTToolbarItem = {
  label: string;
  icon: JSX.Element;
  color: LzTThemeColor;
  route?: string;
  routeParams?: LzTOpenObject;
  type?: 'buttons' | 'icons';
  variant?: 'text' | 'outlined' | 'contained';
  onClick?: LzTFunctionSimple;
  sortOrder?: number;
};

export interface LzPToolbar {
  items: LzTToolbarItem[];
  buttons?: boolean;
  icons?: boolean;
  highlighted?: boolean;
  otherStack?: any;
}

const LzXToolbar = (props: LzPToolbar) => {
  if (
    typeof props.items === 'undefined' ||
    !props.items ||
    props.items.length < 1
  ) {
    return null;
  }

  const renderItem = (
    item: LzTToolbarItem,
    defaultIsButtons: boolean,
    clickCallback?: React.MouseEventHandler<HTMLButtonElement>
  ) => {
    const isButton = item.type ? 'buttons' === item.type : defaultIsButtons;

    if (isButton) {
      return (
        <Button
          className={'lz-button-' + (item.color || '')}
          variant={item.variant || 'text'}
          startIcon={item.icon}
          onClick={clickCallback}
        />
      );
    }

    return (
      <Tooltip title={item.label}>
        <IconButton
          className={'lz-icon-button-' + (item.color || '')}
          onClick={clickCallback}
        >
          {item.icon}
        </IconButton>
      </Tooltip>
    );
  };

  const defaultIsButtons = props.buttons || !props.icons;

  const sortedItems = lzFSortArrayOfObjectsByPosition(
    props.items,
    'sortOrder'
  ) as LzTToolbarItem[];

  return (
    <Toolbar
      className={'lz-toolbar' + (props.highlighted ? ' highlighted' : '')}
    >
      {props.otherStack && (
        <div className='lz-other-stack'>{props.otherStack}</div>
      )}

      {sortedItems.map((item, dex) => (
        <React.Fragment key={'item-' + dex}>
          {/* typeof item.onClick === 'function' */}
          {item.route && item.route !== '' ? (
            <Link to={item.route} state={item.routeParams}>
              {renderItem(item, defaultIsButtons)}
            </Link>
          ) : (
            renderItem(item, defaultIsButtons, item.onClick)
          )}
        </React.Fragment>
      ))}
    </Toolbar>
  );
};

export default LzXToolbar;
